import React from 'react';
import EnhancedAISlidesGenerator from './EnhancedAISlidesGenerator';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Badge } from '@/components/ui/badge';
import { Slider } from '@/components/ui/slider';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import {
  Presentation,
  Download,
  Play,
  ChevronLeft,
  ChevronRight,
  Plus,
  Edit,
  Trash2,
  Save,
  FileText,
  Maximize,
  X,
  Loader2,
  Image as ImageIcon,
  Quote } from
'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { geminiService } from '@/services/geminiService';
import { motion, AnimatePresence } from 'motion/react';
import { useAuth } from '@/contexts/AuthContext';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

interface Slide {
  id: string;
  title: string;
  content: string;
  type: 'title' | 'content' | 'image' | 'list' | 'conclusion' | 'quote' | 'comparison' | 'image-text';
  notes?: string;
  imageUrl?: string;
  imageAlt?: string;
  layout?: 'default' | 'split' | 'overlay' | 'minimal' | 'bold';
}

interface Presentation {
  id: string;
  title: string;
  description: string;
  slides: Slide[];
  createdAt: Date;
  updatedAt: Date;
}

interface LessonPlan {
  id: number;
  title: string;
  subject: string;
  grade_level: string;
  content: string;
  objectives: string;
}

const AISlidesGenerator: React.FC = () => {
  return <EnhancedAISlidesGenerator data-id="nitxoac5o" data-path="src/components/ai/AISlidesGenerator.tsx" />;
};

export default AISlidesGenerator;